var map = {
	"./doc.png": "db0e",
	"./docx.png": "177b",
	"./jpg.png": "5b18f",
	"./pdf.png": "8fcf",
	"./png.png": "3b48",
	"./pptx.png": "8974",
	"./unknown.png": "edcb",
	"./xls.png": "a009",
	"./xlsx.png": "546a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f10";